'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import CheckoutProgress from './components/CheckoutProgress.vue';

var _class = function _class() {
  _classCallCheck(this, _class);

  // Register component globaly
  Vue.component('checkout-progress', CheckoutProgress);
};

export default _class;


//////////////////
// WEBPACK FOOTER
// ./resources/templates/semperit/assets/js/modules/checkout/components/checkout-progress/index.js
// module id = null
// module chunks = 